/**
 * Single entry point for GSAP. Import gsap, ScrollTrigger, SplitText and useGSAP
 * from here so plugins are registered exactly once.
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger, SplitText, useGSAP);

/** Matches the CSS `ease-expo` curve: cubic-bezier(0.16, 1, 0.3, 1). */
export const EASE = 'expo.out';

/** gsap.matchMedia() conditions shared by every section. */
export const MOTION_OK = '(prefers-reduced-motion: no-preference)';
export const REDUCED = '(prefers-reduced-motion: reduce)';
export const DESKTOP = '(min-width: 768px)';

gsap.defaults({ ease: EASE, duration: 1 });

export { gsap, ScrollTrigger, SplitText, useGSAP };
